// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3FELF","footer":"ModalInfo_footer__CYCD8"};